import api from '@/services/api/api'

class FileService {
  getFileData (fileId) {
    return api.get('file', {
      params: {
        fileId: fileId
      } }).then(result => {
      return result.data
    })
  }
  createUploadSession () {
    return api.post('file/create-upload-session').then(result => {
      return result.data
    })
  }
  cleanupUploadSession (guid) {
    return api.post('file/cleanup-upload-session', {
      guid: guid
    })
  }
  uploadImage (guid, file) {
    const formData = new FormData()
    formData.append('guid', guid)
    formData.append('image', file)

    return api.post('file/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }}).then(result => {
      return result.data
    })
  }
  uploadAttachment (guid, file) {
    const formData = new FormData()
    formData.append('guid', guid)
    formData.append('attachment', file)

    return api.post('file/upload-attachment', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }}).then(result => {
      return result.data
    })
  }
  openDownload (fileId) {
    return api.get('file/' + fileId + '/open-download').then(result => {
      return result.data
    }, _ => {
      // todo: error
    })
  }
}

export default new FileService()



// WEBPACK FOOTER //
// ./src/services/file/FileService.js